"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwIfNotOk = void 0;
function throwIfNotOk(response) {
    if (!response.ok) {
        throw new Error(`unexpected response status ${response.status}`);
    }
}
exports.throwIfNotOk = throwIfNotOk;
//# sourceMappingURL=throwIfNotOk.js.map